import { createContext } from "react";

import {
    EncodeSpecificationItem,
    EncodeSpecificationMpeg1Item,
    EncodeSpecificationMpeg4Item
} from "./EncodeSpecificationItem";
import {
    UpdateEncodeSpecificationMpeg1Props,
    UpdateEncodeSpecificationMpeg4Props
} from "./EncodeSpecificationProvider";

interface IEncodeSpecificationContext {
    encodeSpecifications: EncodeSpecificationItem[];
    isLoading: boolean;
    addEncodeSpecificationMpeg1(item: EncodeSpecificationMpeg1Item): void;
    addEncodeSpecificationMpeg4(item: EncodeSpecificationMpeg4Item): void;
    updateEncodeSpecificationMpeg1(props: UpdateEncodeSpecificationMpeg1Props): void;
    updateEncodeSpecificationMpeg4(props: UpdateEncodeSpecificationMpeg4Props): void;
}

export const EncodeSpecificationContext = createContext<IEncodeSpecificationContext>({} as IEncodeSpecificationContext);
